import React from "react";
import axios from "axios";
import { Link, browserHistory } from "react-router";
import { clearMfaSetupContext } from "../utils/mfaSetupContext";
import { clearLoginMfaContext, getLoginMfaContext, updateLoginMfaContext } from "../utils/loginMfaContext";
import { errorMessages, finalizeLogin, getApiMessage, handleRequiredMfaSetup } from "./loginFlowUtils";

export default class LoginBackupCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backupCode: "",
      errorMessage: null,
      codeError: null,
      mfaRememberForDays: null,
      rememberMfa: false,
      loading: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onUseDifferentUser = this.onUseDifferentUser.bind(this);
  }

  componentDidMount() {
    if (this.props.authentication && this.props.authentication.user) {
      browserHistory.replace("/events");
      return;
    }

    const context = getLoginMfaContext();
    if (!context || !context.username || !context.password) {
      browserHistory.replace("/login");
      return;
    }

    this.setState({
      rememberMfa: Boolean(context.rememberMfa),
      mfaRememberForDays: context.mfaRememberForDays || null
    });
  }

  onChange(event) {
    const name = event.target.name;
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;

    this.setState({ [name]: value, errorMessage: null, codeError: null });

    if (name === "rememberMfa") {
      updateLoginMfaContext({ rememberMfa: value });
    }
  }

  onUseDifferentUser() {
    clearLoginMfaContext();
    this.setState({ errorMessage: null });
    browserHistory.push("/login");
  }

  onSubmit(event) {
    event.preventDefault();

    const context = getLoginMfaContext();
    if (!context || !context.username || !context.password) {
      clearLoginMfaContext();
      browserHistory.replace("/login");
      return;
    }

    clearMfaSetupContext();
    this.setState({ loading: true, errorMessage: null, codeError: null });

    axios
      .post(
        "/v2/auth/login/",
        {
          username: context.username,
          password: context.password,
          backup_code: this.state.backupCode,
          remember_mfa: this.state.rememberMfa
        },
        {
          withCredentials: true,
          skipAuthRefresh: true,
          skipAuthToken: true,
          validateStatus: (status) => status >= 200 && status < 500
        }
      )
      .then(async (response) => {
        const data = response.data;
        const status = response.status;

        if (status >= 400 && status < 500) {
          if (handleRequiredMfaSetup({ data: data, redirectTo: "/events" })) {
            clearLoginMfaContext();
            this.setState({ loading: false });
            return;
          }

          if (data && data.code === "token_invalid") {
            this.setState({ loading: false, codeError: getApiMessage(data, "Back-up code ongeldig, probeer opnieuw.") });
            return;
          }

          this.setState({ loading: false, errorMessage: getApiMessage(data) });
          return;
        }

        if (status === 200) {
          if (data && data.code === "token_required") {
            this.setState({ loading: false, codeError: getApiMessage(data, "Voer een back-up code in.") });
            return;
          }

          const result = await finalizeLogin({
            data: data,
            setUserData: this.props.setUserData,
            setAuthToken: this.props.setAuthToken,
            redirectTo: "/events"
          });

          if (!result.success) {
            this.setState({ loading: false, errorMessage: errorMessages[result.errorCode] || errorMessages.unknown_error });
            clearLoginMfaContext();
            return;
          }

          clearLoginMfaContext();
          return;
        }

        this.setState({ loading: false, errorMessage: errorMessages.unknown_error });
      })
      .catch((error) => {
        this.setState({ loading: false, errorMessage: errorMessages.unknown_error });
        console.warn("Authentication failed", error);
      });
  }

  render() {
    return (
      <div>
        <div className="form form-signin">
          {this.state.errorMessage && <div className="alert alert-danger">{this.state.errorMessage}</div>}

          <form onSubmit={this.onSubmit}>
            <label htmlFor="backup-code-field">Back-up code</label>
            <input
              id="backup-code-field"
              name="backupCode"
              type="text"
              className={"form-control" + (this.state.codeError ? " is-invalid" : "")}
              autoComplete="one-time-code"
              value={this.state.backupCode}
              onChange={this.onChange}
              required
            />
            {this.state.codeError && <div className="invalid-feedback d-block">{this.state.codeError}</div>}

            {this.state.mfaRememberForDays > 0 && (
              <div className="form-group mt-2">
                <label htmlFor="remember-mfa-backup-field">
                  <input id="remember-mfa-backup-field" name="rememberMfa" type="checkbox" checked={this.state.rememberMfa} onChange={this.onChange} /> MFA niet opnieuw
                  vragen voor {this.state.mfaRememberForDays} dagen op dit apparaat
                </label>
              </div>
            )}

            <div className="form-group mt-2">
              <Link className="btn btn-link p-0" to="/login">
                Gebruik toch een MFA-code
              </Link>
            </div>

            <button className="btn btn-primary btn-block" type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Inloggen..." : "Inloggen"}
            </button>

            <button type="button" className="btn btn-light btn-block" onClick={this.onUseDifferentUser}>
              Inloggen met een andere gebruiker
            </button>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/LoginBackupCode.js